import { get, put } from '@/services/http';

export class LoginRequestModel {
  public id?: string;
  public merchantId: number;
  public customerId: string;
  public agentId: string;
  public agentName: string;
  public agentEmail: string;
  public reason: string;
  public status?: string;
  public requestedAt?: string;
  public respondedAt?: string;
  public expiresAt?: string;
  public accessDurationHours?: number;
  public isExpired?: boolean;
  public agentRequestIp?: string;
  public customerResponseIp?: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.merchantId = data.merchantId || data.merchant_id;
    this.customerId = data.customerId || data.customer_id || '';
    this.agentId = data.agentId || data.agent_id || '';
    this.agentName = data.agentName || data.agent_name || '';
    this.agentEmail = data.agentEmail || data.agent_email || '';
    this.reason = data.reason || '';
    this.status = data.status;
    this.requestedAt = data.requestedAt || data.requested_at;
    this.respondedAt = data.respondedAt || data.responded_at;
    this.expiresAt = data.expiresAt || data.expires_at;
    this.accessDurationHours = data.accessDurationHours || data.access_duration_hours || 24;
    this.isExpired = data.isExpired || data.is_expired;
    this.agentRequestIp = data.agentRequestIp || data.agent_request_ip;
    this.customerResponseIp = data.customerResponseIp || data.customer_response_ip;
  }

  public async respond(status: 'approved' | 'rejected') {
    const response: any = await put(`/login-requests/${this.id}/respond`, { status });
    const data = response?.data ?? response;
    this.mapData(data);
  }

  public mapData(data: any = {}) {
    this.id = data.id;
    this.merchantId = data.merchantId || data.merchant_id;
    this.customerId = data.customerId || data.customer_id;
    this.agentId = data.agentId || data.agent_id;
    this.agentName = data.agentName || data.agent_name;
    this.agentEmail = data.agentEmail || data.agent_email;
    this.reason = data.reason;
    this.status = data.status;
    this.requestedAt = data.requestedAt || data.requested_at;
    this.respondedAt = data.respondedAt || data.responded_at;
    this.expiresAt = data.expiresAt || data.expires_at;
    this.accessDurationHours = data.accessDurationHours || data.access_duration_hours;
    this.isExpired = data.isExpired || data.is_expired;
    this.agentRequestIp = data.agentRequestIp || data.agent_request_ip;
    this.customerResponseIp = data.customerResponseIp || data.customer_response_ip;
  }
}
